const $participantSelect = $('#participantSelect');

$participantSelect.selectize();
